import { Box, Typography } from "@mui/material"

export interface EmptyStateProps {
  label?: string
}

export const EmptyState = ({ label = "Aucun résultat" }: EmptyStateProps) => (
  <Box sx={{ px: 2, py: 1 }}>
    <Typography color="text.secondary">{label}</Typography>
  </Box>
)
